import type { MhElement } from '../../shared/interfaces';

import { getInfoFromParams } from './get-info-from-params';

export const createMissingElements = (form: HTMLFormElement, elements: Record<string, MhElement>) => {
    const infoFromParams = getInfoFromParams();

    Object.entries(infoFromParams).forEach(([fieldName, value]: [string, any]) => {
        const element = elements[fieldName];
        if (!element) {
            // Dynamically create elements for information passed in mh query param.
            const input = document.createElement(`input`);
            input.type = `hidden`;
            input.style.display = `none`;
            input.value = value;
            form.prepend(input);

            elements[fieldName] = {
                anchor: input,
                feedback: undefined,
                input,
            };
            return;
        }

        if (element.input) {
            element.input.value = value;
        }
    });
};
